import './styles.css';
import { createPlayBackend } from './backend/createPlayBackend';
import { installClientErrorLog } from './ui/clientErrors';
import { createGame } from './game/createGame';
import { GameController } from './ui/controller';
import { mountShell } from './ui/shell';

installClientErrorLog();

const controller = new GameController(await createPlayBackend());
controller.boot();
await controller.ready;

const status = document.querySelector<HTMLElement>('#status');
const panel = document.querySelector<HTMLElement>('#panel');
const modal = document.querySelector<HTMLElement>('#modal-root');
const tabs = document.querySelector<HTMLElement>('#tabs');
const feedback = document.querySelector<HTMLElement>('#feedback-root');

if (!status || !panel || !modal || !tabs || !feedback) {
  throw new Error('Threadbound shell is missing.');
}

mountShell(controller, { status, panel, modal, tabs, feedback });
createGame('stage', controller);
